import { FC } from 'react';
import FiltersDialog from '../components/FiltersDialog';
import { FiltersFormValues } from '../components/FiltersForm';

interface Props {
  open: boolean;
  selectedFilters?: FiltersFormValues;
  onClose: () => void;
  onFiltersApply: (f: FiltersFormValues) => void;
  onFiltersClear: () => void;
}

const AffiliateLeadsFiltersDialog: FC<Props> = ({
  open,
  selectedFilters,
  onClose,
  onFiltersApply,
  onFiltersClear,
}) => {
  return (
    <FiltersDialog
      fields={[
        {
          key: 'status',
          label: 'Status',
          type: 'select',
          defaultMode: 'equals',
          nullable: false,
          options: ['Uploaded', 'Draft', 'MarkedForUpload', 'Processing', 'Failed'],
        },
        {
          key: 'firstName',
          label: 'First Name',
          type: 'string',
          nullable: true,
          defaultMode: 'contains',
        },
        {
          key: 'lastName',
          label: 'Last Name',
          type: 'string',
          nullable: true,
          defaultMode: 'contains',
        },
        { key: 'email', label: 'Email', type: 'string', nullable: true, defaultMode: 'contains' },
        {
          key: 'phoneNumber',
          label: 'Phone Number',
          type: 'string',
          nullable: true,
          defaultMode: 'contains',
        },
        { key: 'city', label: 'City', type: 'string', nullable: true, defaultMode: 'contains' },
        { key: 'state', label: 'State', type: 'string', nullable: true, defaultMode: 'contains' },
        {
          key: 'address',
          label: 'Address',
          type: 'string',
          nullable: true,
          defaultMode: 'contains',
        },
        {
          key: 'zipCode',
          label: 'Zip Code',
          type: 'string',
          nullable: true,
          defaultMode: 'contains',
        },
        {
          key: 'contactDate',
          label: 'Contact Date',
          type: 'date',
          nullable: true,
          range: true,
          defaultMode: 'equals',
        },
        {
          key: 'createdAt',
          label: 'Created At',
          type: 'date',
          nullable: true,
          range: true,
          defaultMode: 'equals',
        },
        {
          key: 'uploadedAt',
          label: 'Uploaded At',
          type: 'date',
          nullable: true,
          range: true,
          defaultMode: 'equals',
        },
        {
          key: 'isApproved',
          label: 'Is Approved',
          type: 'select',
          options: ['true', 'false'],
          nullable: true,
          defaultMode: 'equals',
        },
        { key: 'dba', label: 'DBA', type: 'string', nullable: true, defaultMode: 'contains' },
      ]}
      open={open}
      selectedFilters={selectedFilters}
      handleClose={onClose}
      onFiltersApply={onFiltersApply}
      onFiltersClear={onFiltersClear}
    />
  );
};

export default AffiliateLeadsFiltersDialog;
